export default function MySQL_BINARY() {
  return (
    <div>
      <h2>MySQL_BINARY</h2>    </div>
  );
}